import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAppContext } from '../App';
import styles from './Layout.module.css';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const { isAdmin, settings } = useAppContext();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    { path: '/', label: 'Map', icon: '🗺️' },
    { path: '/mission', label: 'Mission', icon: '🎯' },
    { path: '/admin', label: isAdmin ? 'Admin' : 'Login', icon: '🔐' },
  ];

  const isActive = (path: string) => location.pathname === path;

  const headerStyle = {
    background: settings.headerBgColor || '#9a3612',
    color: settings.headerTextColor || '#ffffff',
  };

  const logoStyle = {
    fontFamily: `'${settings.logoFont || 'The Seasons'}', Georgia, serif`,
    fontSize: `${settings.logoFontSize || 1.5}rem`,
    color: settings.logoColor || '#ffffff',
  };

  const navLinkStyle = (active: boolean) => ({
    color: active ? settings.headerTextColor : `${settings.headerTextColor}b3`,
  });

  return (
    <div className={styles.layout}>
      <header className={styles.header} style={headerStyle}>
        <div className={styles.headerInner}>
          <Link to="/" className={styles.logo}>
            <div className={styles.logoContent}>
              <div className={styles.logoTop}>
                <span className={styles.logoTitle} style={logoStyle}>{settings.logoText || 'Pin the Poo'}</span>
                <span className={styles.logoIcon}>🐾</span>
              </div>
              {settings.tagline && (
                <span className={styles.tagline} style={{ color: `${settings.headerTextColor}cc` }}>
                  {settings.tagline}
                </span>
              )}
            </div>
          </Link>

          <button 
            className={styles.mobileMenuBtn}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span className={styles.hamburger} data-open={mobileMenuOpen} style={{ '--hamburger-color': settings.headerTextColor } as React.CSSProperties}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>

          <nav className={`${styles.nav} ${mobileMenuOpen ? styles.navOpen : ''}`} style={{ background: settings.headerBgColor }}>
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`${styles.navLink} ${isActive(item.path) ? styles.navLinkActive : ''}`}
                style={navLinkStyle(isActive(item.path))}
                onClick={() => setMobileMenuOpen(false)}
              >
                <span className={styles.navIcon}>{item.icon}</span>
                <span className={styles.navLabel}>{item.label}</span>
              </Link>
            ))}
          </nav>
        </div>
      </header>

      <main className={styles.main}>
        {children}
      </main>
    </div>
  );
};

export default Layout;
